import { render, staticRenderFns } from "./ArticleThumb.vue?vue&type=template&id=2639f086&scoped=true"
import script from "./ArticleThumb.vue?vue&type=script&lang=js"
export * from "./ArticleThumb.vue?vue&type=script&lang=js"
import style0 from "./ArticleThumb.vue?vue&type=style&index=0&id=2639f086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2639f086",
  null
  
)

export default component.exports